<template>
  <transition-group name='fade'>
    <div @click="defaultMask" @touchmove.prevent class="mask" key="1" v-if="show"></div>
    <div class="video-pop" key="2" v-show="show"  >
      <div class="video-pop-title">{{videoShow}}</div>
      <div class="video-pop-content">
        <div class="video-pop-deviceList">
          <el-select @change="selectDeviceSerial($event)" v-model="deviceSerialSelect" :placeholder=choose class="deviceList-title">
            <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in deviceSerialList"></el-option>
          </el-select>
          <el-tag class="deviceList-select">{{deviceList}}</el-tag>
        </div>
        <div :key="videoKey" id="video-container" class="video-pop-deviceShow">{{errorMessage}}</div>
      </div>
    </div>
  </transition-group>
</template>

<script>
  import EZUIKit from 'ezuikit-js'
  import axios from "axios"
  import {getAttributesShared} from "../../untils/api/home";
  export default {
    name: 'videoDialog',
    props: {
      deviceInfo: {}
    },
    data() {
      return {
        show: false,
        player: null,
        accessToken: '',
        newURL:'',
        src: '',
        appKey: '',
        secret: '',
        defaultDevice:'',
        address:[],
        deviceSerialList: [],
        deviceSerialSelect: '',
        windowHeight: document.documentElement.clientHeight,
        windowWidth: document.documentElement.clientWidth,
        appKeyStr: '',
        channelNo: 1,
        videoTime:null,
        videoKey: Date.now(),
        videoShow: '',
        choose:'',
        deviceList: '',
        errorMessage:''
      }
    },

    mounted() {
      if (window.history && window.history.pushState) {
        window.addEventListener("popstate", this.defaultMask, false);
      }
      if(localStorage.getItem('locale') === 'en-US'){
        this.videoShow = ' Video Monitoring ';
        this.choose = 'Please Select';
        this.deviceList = 'Device';
        this.errorMessage = 'No Camera Found';
      } else {
        this.videoShow = '视频监控';
        this.choose = '请选择';
        this.deviceList = '设备列表';
        this.errorMessage = '未查询到摄像头';
      }
      this.getSelectDevice();
    },

    destroyed() {
      window.removeEventListener("popstate", this.defaultMask, false);
      clearInterval(this.videoTime);
    },

    methods: {
      defaultMask() {
        this.show = false;
      },

      getSelectDevice() {
        this.appKey = '';
        this.secret = '';
        this.address = [];
        this.deviceSerialList = [];
        this.defaultDevice = '';
        this.deviceSerialSelect = '';
        let num = 0;
        getAttributesShared(this.deviceInfo.entityType,this.deviceInfo.id ).then(response => {
          for(let i = 0; i < response.length; i++) {
            if(response[i].key.toString().indexOf('vedio') !== -1) {
              let json = JSON.parse(response[i].value);
              let deviceSerialJson = {};
              deviceSerialJson.id = num; //设备id
              deviceSerialJson.name = json.deviceSerial;//设备名
              this.deviceSerialSelect = num;//选中设备id
              this.address.push(json);//监控信息
              this.appKey = json.appKey;
              this.secret = json.secret;
              this.channelNo = 1;
              if(json.deviceSerial.indexOf('-') !== -1) {
                this.defaultDevice = json.deviceSerial.split("-")[0];
                this.channelNo = json.deviceSerial.split("-")[1];
              } else {
                this.defaultDevice = json.deviceSerial;//选中的设备
              }
              this.deviceSerialList.push(deviceSerialJson);//设备列表
              num++;
            }
          }
          if(this.appKey !== '' && this.secret !== '' && this.defaultDevice !== '') {
            this.setVideo();
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      selectDeviceSerial(event) {
        this.appKey = this.address[event].appKey;//appley
        this.secret = this.address[event].secret;//secret
        let deviceNum = this.address[event].deviceSerial;//选中设备名称
        this.channelNo = 1;
        if(deviceNum.indexOf('-') !== -1) {
          this.defaultDevice = deviceNum.split("-")[0];
          this.channelNo = deviceNum.split("-")[1];
        } else {
          this.defaultDevice = deviceNum;//选中的设备
        }
        this.deviceSerialSelect = event;//选中设备id
        this.setVideo();
      },

      setVideo() {
        clearInterval(this.videoTime);
        this.videoTime = null;

        // 获取 token 和播放地址
        this.getAccessToken().then(() => {
          return this.getURL();
        }).then(() => {
          // 确保 DOM 更新完成
          this.$nextTick(() => {
            this.setPlayVideo(); // 调用播放器

            // 定时刷新
            this.videoTime = setInterval(() => {
              this.setPlayVideo();
            }, 1000 * 60 * 10);
          });
        });
      },

      setPlayVideo() {
        // 1. 销毁旧播放器
        if (this.player && typeof this.player.stop === 'function') {
          this.player.stop();
        }
        this.player = null;

        // 2. 强制刷新容器
        this.videoKey = Date.now();

        // 3. 延时创建新播放器
        this.$nextTick(() => {
          setTimeout(() => {
            const options = {
              autoplay: true,
              id: 'video-container',
              accessToken: this.accessToken,
              url: this.newURL,
              template: this.channelNo == 1 ? 'theme' : 'simple',
              width: this.windowWidth * 0.52,
              height: this.windowHeight * 0.52
            };

            this.player = new EZUIKit.EZUIKitPlayer(options);
          }, 200); // 适当延时，确保 DOM 真正存在
        });
      },

      getAccessToken() {
        let url = '/api/lapp/token/get?appKey=' + this.appKey + '&appSecret=' + this.secret;
        return axios({
          method: 'post',
          baseURL: process.env.API, // 修改这里
          url,
          headers: {
            'Content-Type':'application/x-www-form-urlencoded'
          },
          timeout: 10000

        }).then((response) => {
          this.accessToken = response.data.accessToken;
        }) .catch((error) => {
          console.log("error",error)
        })
      },

      getURL() {
        const url = '/api/lapp/v2/live/address/get?accessToken=' + this.accessToken + '&deviceSerial=' + this.defaultDevice + '&channelNo=' + this.channelNo;
        return axios({
          method: 'post',
          baseURL: process.env.API,
          url,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          timeout: 10000
        }).then((response) => {
          this.newURL = response.data.url;
        }).catch((error) => {
          console.log("getURL error", error);
          this.newURL = 'ezopen://open.ys7.com/' + this.defaultDevice + '/1.hd.live';
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  // 渐变过渡
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s;
  }

  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
  }

  .video-pop {
    width: 55vw;
    height: 70vh;
    background: #58a1ff;
    border-radius: 8px;
    position: fixed;
    top: 15%;
    left: 25%;
    z-index: 1000;
    text-align: center;

    .video-pop-title {
      width: 100%;
      height: 10%;
      text-align: center;
      font-size: 22px;
      padding-top: 0.5%;
      color: #ffffff;

    }

    .video-pop-content {
      width: 98%;
      height: 90%;
      margin-left: 1%;

      .video-pop-deviceList {
        width: 100%;
        height: 10%;
        padding-top: 1%;

        .deviceList-title {
          float: right;
          padding: 0.5% 1% 0 0
        }

        .deviceList-select {
          float: right;
          padding-top: 0.5%;
          font-size: 18px
        }
      }

      .video-pop-deviceShow {
        width: 100%;
        height: 88%;
        margin-top: 1%;
        font-size: 22px;
        color: red
      }
    }

    .el-tag{
      margin-top: 5px;
      background-color: transparent;
      border: none;
      font-size: 14px;
      color: #ffffff;
    }

    .el-input {
      width: 90%;
      /*margin-left: -30px;*/
      font-size: 16px;
    }

    /deep/ .el-input__inner {
      background-color: transparent;
      color: #1BFFE6;
      font-size: 16px;
      border: 1px solid #ffffff; /* 加上默认边框 */
    }

    /deep/ .el-input__inner:focus {
      border: 1px solid #1BFFE6 !important; /* 选中时显示你想要的颜色边框 */
      box-shadow: 0 0 4px #1BFFE6; /* 可选：加点发光视觉 */
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/popup/videoDialog.vue